export default __webpack_public_path__ + "static/media/hLINK.6aa27071.svg";